export const retailLogos = {
  "walmart": 3,
  "hardwareandmoreee": 11,
  "cmple": 10,
  "homedepot": 1,
  "zoro": 2,
  "target": 4,
  "gamestop": 13,
  "bestbuy": 12,
  "barnesandnoble": 40,
  "fatbraintoys": 15,
  "maxwarehouse": 16,
  "macys": 14,
  "kohls": 8,
  "dickssportinggoods": 18,
  "kiehls": 17,
  "samsclub": 21,
  "acmetools": 20,
  "vitacost": 22,
  "lowes": 23,
  "farmandfleet": 25,
  "bjs": 24,
  "dollargeneral": 26,
  "boscovs": 27,
  "cvs": 28,
  "chewy": 29,
  "rarebeauty": 41,
  "jcpenney": 30,
  "bhphotovideo": 31,
  "academy": 32,
  "ecosmetics": 33,
  "truevalue": 34,
  "amerilifevitamin": 37,
  "petsmart": 35,
  "dkhardware": 36,
  "zappos": 38,
  "kmart": 39,
  "acehardware": 42,
  "b2bsportswear": 43,
  "bathandbodyworks": 44,
  "gisou": 45,
  "kvdveganbeauty": 46,
  "milkmakeup": 47,
  "nyfragrancesupply": 48,
  "oseamalibu": 49,
  "patrickta": 50,
  "shopwss": 51,
  "frontiercoop": 52,
  "everythingkitchens": 53,
  "hardwareandtools": 54,
  "michaels": 55,
  "officedepot": 56,
  "pureformulas": 57,
  "bedbathandbeyond": 58,
  "fragrancenet": 59,
  "fleetfarm": 60,
  "fivebelow": 61,
  "nike": 62,
  "belk": 63,
  "snipesusa": 64,
  "underarmour": 65,
  "crocs": 66, 
  "heb": 68, 
  "sephora": 69, 
  "yankeecandle": 70,
  "champssports": 71,
  "gnc": 72,
  "cosmetixclub": 80,
  "empirediscount": 81,
  "famousfootwear": 82,
  "findtape": 83,
  "glwholesale": 84,
  "hjcloseouts": 85,
  "honeysplace": 86,
  "iherb": 87,
  "koleimports": 88,
  "leedistributors": 89,
  "lvdistribution": 90,
  "mazaldistribution": 91,
  "nexdeal": 92,
  "palletfly": 93,
  "regentproducts": 94,
  "savoyactive": 95,
  "shoppremiumoutlets": 96,
  "somethingdifferentwholesale": 97,
  "ssisports": 98,
  "tjsgroupllc": 99,
  "topdawg": 100,
  "utnwholesale": 101,
  "webstaurantstore": 102,
  "weinersltd": 103,
  "twhouse": 105,
  "4sgm": 106,
  "888lots": 107,
  "advancedistributors": 108,
  "b-gsales": 109,
  "beautyjoint": 113,
  "bulkbuyamerica": 114,
  "discountwholesalersinc": 115,
  "dollartree": 116,
  "dpciwholesale": 117,
  "adosurprise": 118,
  "ecomwholesaledeals": 119,
  "greatdiscounters": 120,
  "gsp": 121,
  "hacknabra": 122,
  "kaywholesaledeals": 123,
  "kikowireless": 124,
  "kntradingllc": 125,
  "medistributors": 126,
  "megagoods": 127,
  "minmaxdeals": 128,
  "nat-procurement": 129,
  "northandsouthwholesalers": 130,
  "wholesale-perfume": 131,
  "topperliquidators": 132,
  "joann": 133, 
  "officesupply": 134, 
  "rei": 135, 
  "restaurantsupply": 136, 
  "riteaid": 137, 
  "vitaminshoppe": 138,
  "walgreens": 139,
  "shoprite": 140,
  "big5sportinggoods": 141,
  "dillards": 142,
  "kroger": 143,
  "haircareandbeauty": 144,
  "altomusic": 145,
  "annscottage": 146,
  "aerosoles": 147,
  "1000bulbs": 148,
  "toolnut": "toolnut",
  "alexandalexa": "alexandalexa",
  "allstarhealth": "allstarhealth",
  "asics": "asics", "bangalla": "bangalla", "basspro": "basspro", "bbtoystore": "bbtoystore", "beautybrands": "beautybrands", "beautyencounter": "beautyencounter", "beautylish": "beautylish", "bettymills": "bettymills", "bloomingdales": "bloomingdales", "bloomingkoco": "bloomingkoco", "bluemercury": "bluemercury", "bonton": "bonton", "brandsmartusa": "brandsmartusa", "buydig": "buydig", "calendars": "calendars", "campmor": "campmor", "caretobeauty": "caretobeauty", "clinique": "clinique", "dermstore": "dermstore", "disneystore": "disneystore", "drugsupplystore": "drugsupplystore", "e-cosmetorium": "e-cosmetorium", "entirelypets": "entirelypets", "familydollar": "familydollar", "faucetdirect": "faucetdirect", "fingerhut": "fingerhut", "fishpondusa": "fishpondusa", "footsmart": "footsmart", "fpnyc": "fpnyc", "fruitfulyield": "fruitfulyield", "fye": "fye", "gardeners": "gardeners", "gearheadoutfitters": "gearheadoutfitters", "globalgolf": "globalgolf", "goinggoinggone": "goinggoinggone", "hartmannvariety": "hartmannvariety", "hasbropulse": "hasbropulse", "healthypets": "healthypets", "hearthsong": "hearthsong", "herbspro": "herbspro", "holabirdsports": "holabirdsports", "hy-vee": "hy-vee", "jefferspet": "jefferspet", "journeys": "journeys", "keepsakequilting": "keepsakequilting", "ldproducts": "ldproducts", "lenox": "lenox", "lifeextension": "lifeextension", "lionbrand": "lionbrand", "luggagepros": "luggagepros", "masseysoutfitters": "masseysoutfitters", "mattel": "mattel", "meijer": "meijer", "melissaanddoug": "melissaanddoug", "microcenter": "microcenter", "miniaturemarket": "miniaturemarket", "morphe": "morphe", "myotcstore": "myotcstore", "mytoolstore": "mytoolstore", "netrition": "netrition", "newegg": "newegg", "northerntool": "northerntool", "olly": "olly", "opentip": "opentip", "packershoes": "packershoes", "parts-express": "parts-express", "pcrichard": "pcrichard", "peltzshoes": "peltzshoes", "perpetualkid": "perpetualkid", "petedge": "petedge", "petflow": "petflow", "petmountain": "petmountain", "pier1": "pier1", "pinkcherry": "pinkcherry", "pishposhbaby": "pishposhbaby", "rinovelty": "rinovelty", "roadrunnersports": "roadrunnersports", "ruralking": "ruralking", "saucony": "saucony", "sears": "sears", "ssww": "ssww", "sunandski": "sunandski", "swimoutlet": "swimoutlet", "target": "target", "tfaw": "tfaw", "toywiz": "toywiz", "us.puma": "us.puma", "vitaminlife": "vitaminlife", "woodcraft": "woodcraft",
  // Ghost suppliers from the 2026-08-12 integration audit. nepeto-backend!85 put them in
  // RETAIL_LIST; these are the matching tiles. hobbylobby and moidaus are still artwork-only —
  // leave them unmapped until their PNG lands, or the guard passes and renders a broken image.
  "balega": "balega",
  "hobbylobby": "hobbylobby",
  "kvdbeauty": "kvdbeauty",
  "miraiclinical": "miraiclinical",
  "moidaus": "moidaus",
  "regowholesale": "regowholesale",
  "shop.mattel": "shop.mattel",
  "toolup": "toolup",
  // Second batch. Keys are the pipeline's source_name verbatim (SELECT DISTINCT source_name
  // FROM gcprofit_dataset.apex_leads), not the domain — "lauren-records" hyphenates where the
  // artwork filename did not, and "eeschenck" is EE Schenck Company.
  "contarmarket": "contarmarket",
  "eeschenck": "eeschenck",
  "hardwareworld": "hardwareworld",
  "lauren-records": "lauren-records",
  "lifeandhome": "lifeandhome",
  "us.jellycat": "us.jellycat",
  // No leads in apex_leads yet, so these keys are inferred from the domain and are the ones to
  // re-check when their first batch lands.
  "32degrees": "32degrees",
  "aromar": "aromar",
  "innbeautyproject": "innbeautyproject",
  "miriamquevedo": "miriamquevedo"
}